import * as Scrivito from "scrivito";
import getLanguage from "../../../../utils/getLanguage";

function GoNextButton(props) {
  const lang = getLanguage(Scrivito.currentPage());
  return (
    <Scrivito.LinkTag
      className="btn btn-outline-primary ml-auto"
      onClick={props.nextPage}
    >
      <span className="form-page-buttons-next">
        {lang === "de" ? "Weiter" : "Next"}
      </span>
      <i className="las la-angle-right" />
    </Scrivito.LinkTag>
  );
}

export default GoNextButton;
